import { Component, OnDestroy } from "@angular/core";
import { ICellRendererParams } from "@ag-grid-community/core";
import { FormControl } from "@angular/forms";
import { AvailablePos } from "../../models/planyard.model";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-select-po-cell-renderer",
  templateUrl: "./select-po-cell-renderer.component.html",
  styleUrls: ["./select-po-cell-renderer.component.scss"],
})
export class SelectPoCellRendererComponent implements OnDestroy {
  params: any;
  selectedVendorItemId: number;
  options: AvailablePos[] = [
    {
      poId: 0,
      poName: "New Draft",
      vendorId: null,
    },
  ];
  selectedOption: number;
  vendor: any;
  control: FormControl = new FormControl(0);
  private destroy$ = new Subject<void>();

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.setData(this.params);

    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => this.savePoOnItem(e));
  }

  refresh(params: ICellRendererParams) {
    this.options = [
      {
        poId: 0,
        poName: "New Draft",
        vendorId: null,
      },
    ]
    this.setData(params);
  }

  setData(params) {
    this.selectedVendorItemId = params.data.selectedVendorItemId;
    this.options.push(
      ...this.params.options(params.data.selectedVendorId)
    );

    this.selectedOption = params.data.selectedPoId || 0;
    this.control.patchValue(this.selectedOption, { emitEvent: false });
    if (this.options.length === 1 || !this.selectedVendorItemId) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  savePoOnItem(e): void {
    if (e) {
      this.params.optionsSelected({
        itemVendorID: this.params.data.selectedVendorItemId,
        poId: +e,
      }, this.params.data.itemId);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
